import i18next, { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import NoDataLayer from '../../../../../Common/NoDataLayer';

class ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: !this.props.inputParam_UseFake ?
                (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.item.l_series.length > 0 ?
                    this.props.inputParam_ComponentContent.item.l_series.map(x => ({name: x.nombre, data : x.l_vals})) :
                    []
                ) : 
                [
                    {
                        name: 'PRODUCT A',
                        data: [44, 55, 41, 67, 22, 43]
                    }, {
                        name: 'PRODUCT B',
                        data: [13, 23, 20, 8, 13, 27]
                    }, {
                        name: 'PRODUCT C',
                        data: [11, 17, 15, 15, 21, 14]
                    }, {
                        name: 'PRODUCT D',
                        data: [21, 7, 25, 13, 22, 8]
                    }
                ],
            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 10,
                        borderRadiusApplication: 'end', // 'around', 'end'
                        borderRadiusWhenStacked: 'last', // 'all', 'last'
                        dataLabels: {
                            total: {
                                enabled: false,
                            }
                        }
                    },
                },
                yaxis: {
                    labels: {
                        formatter: (value) => {
                        return value !== null ? parseFloat(value.toFixed(2)).toLocaleString(i18next.language) : value;
                        }
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                xaxis: {
                    type: 'category',
                    categories: !this.props.inputParam_UseFake ? 
                        (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.item.l_categorias.length > 0 ? this.props.inputParam_ComponentContent.item.l_categorias : [])
                        : ['01/2011', '02/2011', '03/2011', '04/2011', '05/2011', '06/2011'],
                },
                legend: {
                    position: 'bottom',
                },
                fill: {
                    opacity: 1
                }
            },
        };
    }

    static propTypes = {
            inputParam_HideHeader: PropTypes.bool,
            inputParam_UseFake: PropTypes.bool,
    };

    static defaultProps = {
        inputParam_HideHeader: false,
        inputParam_UseFake: false,
    };

    renderContent() {
        return  <Row className='px-3 h-100' style={{opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
                    <Col className='p-0 m-auto h-100'>
                        {
                            this.state.series.length > 0 ?
                            <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height="100%" width="100%" /> :
                            <NoDataLayer display={true} />
                        }
                    </Col>
                </Row>
    }

    render() {
        return (
            <>
                {
                    !this.props.inputParam_UseFake &&
                    <Card className='h-100'>
                        <Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                                { this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.boardComponentTitle !== null ? this.props.inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-monthlyexpenditureperitem')}
                        </Card.Body>
                        <Card.Body className='px-1 py-0 h-100'>
                            {this.renderContent()}
                        </Card.Body>
                    </Card>
                }
                {this.props.inputParam_UseFake && this.renderContent()}
            </>
        );
    }
}

export default ELEMENT_CONTRACT_EDP_PARTIDAS_GRAPH;